export default function Modals () {
  const CONTACT_MODAL = new Modal('contact-modal', '.open-contact-modal, a[href="#open-contact-modal"]')
  const SERVICE_MODAL = new Modal('service-modal', '.open-service-modal, a[href="#open-service-modal"]')
  const PRODUCT_MODAL = new Modal('product-modal', '.open-product-modal, a[href="#open-product-modal"]')
}

class Modal {
  constructor (ELEMENT, SELECTOR) {
    this.ELEMENT = document.getElementById(ELEMENT)
    this.MODELFIELD = this.ELEMENT.querySelector('input[name="model-name"]')
    if (!this.ELEMENT) return

    this.OPEN_BUTTONS = document.querySelectorAll(SELECTOR)
    if (this.OPEN_BUTTONS.length === 0) return

    this.CLOSE_BUTTONS = this.ELEMENT.querySelectorAll('.mtt-modal__close, .mtt-modal__overlay')
    this.eventListeners()
  }

  eventListeners () {
    // Open modal
    for (let i = 0; i < this.OPEN_BUTTONS.length; i++) {
      this.OPEN_BUTTONS[i].addEventListener('click', this.openModal.bind(this))
    }

    // Close modal
    if (this.CLOSE_BUTTONS.length) {
      for (let i = 0; i < this.CLOSE_BUTTONS.length; i++) {
        this.CLOSE_BUTTONS[i].addEventListener('click', this.closeModal.bind(this))
      }
    }

    // Close on escape
    document.addEventListener('keydown', (e) =>
      (e.key === 'Escape' && this.ELEMENT.classList.contains('mtt-modal--show'))
        ? this.closeModal()
        : ''
    )
  }

  openModal (e) {
    e.preventDefault()
    this.ELEMENT.classList.add('mtt-modal--show')
    if (e.target.dataset.modelName === 'undefined') {
      this.MODELFIELD.value = 'Ikke en model'
    } else {
      this.MODELFIELD.value = e.target.dataset.modelName
    }
  }

  closeModal () {
    this.ELEMENT.classList.remove('mtt-modal--show')
  }
}
